import { Fragment } from "react";
import Header from "../../components/Header/Header";
import Preloader from "../../components/Preloader/Preloader";
import { Outlet } from "react-router-dom";
import { useProfileStore } from "../../store/useUserStore";
import Footer from "../../components/Footer/Footer";

const PublicLayout = () => {
    const { loading } = useProfileStore()

    return (
        <Fragment>
            <Header />
            <Outlet/>
            {loading && <Preloader/>}
            <Footer/>
        </Fragment>
    );
};

export default PublicLayout;
